// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"4de66392","885":"4de66392","920":"4de66392"}[chunkId] + ".chunk.css";
};